import Query from "@qpr/client-api-base/querybuilder/Query";
import { ICardElement } from "./model";

export const getChildElements = async (id: string) => {
  return Query(id)
    .childobjects()
    .attributes(
      "name",
      "typename",
      "symbol",
      "description",
      "periodlevel",
      "periodlevelid",
      "periodlevelname"
    )
    .fetchValues<ICardElement>();
};
